import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake.js';
import getImage from './../../../ClinicHistory/ClinicEvent/components/PdfReports/GetImage';
import ReportsAPI from './../../api/reports_api';

const CauseOfMorbidityPDF = async (obj) => {
    pdfMake.fonts = {
        OpenSans: {
            normal: 'OpenSans-Regular.ttf',
            bold: 'OpenSans-Bold.ttf',
            italics: 'OpenSans-Italic.ttf',
            bolditalics: 'OpenSans-ExtraBoldItalic.ttf'
        },
        Merriweather: {
            normal: 'Merriweather-Regular.ttf',
            bold: 'Merriweather-Bold.ttf',
            italics: 'Merriweather-Italic.ttf',
            bolditalics: 'Merriweather-ExtraBoldItalic.ttf'
        },
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Bold.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-BoldItalic.ttf'
        }
    };
    //const city = obj.profile.direccion.id_ciudad;
    const city = sessionStorage.getItem('id_ciudad');
    const getCity = await ReportsAPI.loadCity(city);
    let cityReport= getCity.length > 0 ? getCity[0].ciunom : ' ';

    const getRandomInt = (min, max) => {
        return Math.floor(Math.random() * (max - min)) + min;
    }

    let randomReport = getRandomInt(110, 1);
    let itemBodyFontSize = 9;

    //Tabla de Contenido
    let itemBody = [
        [
            {
                text: "Codigo",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Nombre",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Mujeres",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Hombres",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            },
            {
                text: "Total",
                style: "tableHeader",
                alignment: "center",
                fontSize: itemBodyFontSize
            }
        ],
    ];

    let itemArr = ["", "", "", "", ""];
    if (obj.items.length === 0) itemBody.push(itemArr);
    for (let index = 0; index < obj.items.length; index++) {
        const element = obj.items[index];
        itemBody.push([
            { text: element.codigo, alignment: "center"  },
            { text: element.nombre, alignment: "center" },
            { text: element.mujeres, alignment: "center" },
            { text: element.hombres, alignment: "center" },
            { text: element.total, alignment: "center" },
        ]);
    }

    pdfMake.tableLayouts = {
        exampleLayout: {
            hLineWidth: function (i, node) {
                if (i === 0 || i === node.table.body.length) {
                    return 1;
                }
                return i === node.table.headerRows ? 2 : 1;
            },
            vLineWidth: function (i) {
                return 1;
            },
            hLineColor: function (i, node) {
                if (i === 0 || i === node.table.body.length) {
                    return "black";
                }
                return i === 1 ? "black" : "#aaa";
            },
            fillColor: function (i, node) {
                return i === 0 ? "white" : i % 2 === 0 ? "#e8e8e8" : null;
            },
            paddingLeft: function (i) {
                return i === 0 ? 8 : 8;
            },
            paddingRight: function (i, node) {
                //return i === node.table.widths.length - 1 ? 0 : 8;
                return 3;
            },
            paddingTop: function (i, node) {
                return 3;
            },
            paddingBottom: function (i, node) {
                return 3;
            },

        },
    };

    var docDefinition = {
        pageSize: "LETTER",
        pageOrientation: "portrait",
        info: {
            title: obj.title,
            author: "",
        },

        content: [
            {

                columns: [
                    {
                        width: 125,
                        columns: [
                            {
                                image: await getBase64ImageFromURL(process.env.REACT_APP_PUBLIC_URL + "clinica/" + obj.profile.id_clinica + "/logo/" + sessionStorage.getItem('token')),
                                fit: [180, 90],
                            },
                        ],
                    },
                    {
                        width: "auto",
                        text: [
                            {
                                text: obj.profile.nombre + "\n" +
                                    "NIT:" + obj.profile.nit + "\n" +
                                    obj.profile.direccion.direccion + "\n"
                                    + obj.profile.telefono1 + "\n" +
                                    obj.profile.email
                            },
                        ],
                        alignment: "center"
                    },
                    {
                        text: [
                            {
                                text: obj.title,
                                bold: true,
                                width: "auto",
                                alignment: "right",
                                lineHeight: 1.2,
                                fontSize: 15,
                            },
                        ]

                    },
                ],
            },
            {
                style: "tableExample",
                table: {
                    headerRows: 1,
                    widths: [40, 320, 40, 40, 40],
                    //keepWithHeaderRows: 1,
                    body: itemBody,
                },
                layout: "exampleLayout",
                dontBreakRows: true,
            },
        ],
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                margin: [0, 0, 0, 10],
            },
            subheader: {
                fontSize: 16,
                bold: true,
                margin: [0, 10, 0, 5],
            },
            tableExample: {
                margin: [0, 5, 0, 0],
                fontSize: itemBodyFontSize,
            },
            tableHeader: {
                bold: true,
                fontSize: 9,
                color: "black",
            },
        },
        defaultStyle: {
            columnGap: 15,
        },
    };

    const pdfDocGenerator = pdfMake.createPdf(docDefinition);
    pdfDocGenerator.getDataUrl(function (outDoc) {
        document.getElementById('pdfV').src = outDoc;
    });
};

const getBase64ImageFromURL = (url) => {
    return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.onload = () => {
            var canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;

            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            var dataURL = canvas.toDataURL("image/png");

            resolve(dataURL);
        };

        img.onerror = error => {
            reject(error);
        };

        img.src = url;
    });
}

export default CauseOfMorbidityPDF;